//#region src/pollForWindowObject.ts
function e(e, t = {}) {
	let { interval: n = 100, timeout: r = 5e3 } = t, i = Date.now();
	return new Promise((t, a) => {
		let o = () => {
			let s = e.split(".").reduce((e, t) => e?.[t], window);
			if (s !== void 0) {
				t(s);
				return;
			}
			if (Date.now() - i >= r) {
				a(/* @__PURE__ */ Error(`Timeout waiting for window.${e}`));
				return;
			}
			setTimeout(o, n);
		};
		o();
	});
}
//#endregion
export { e as pollForWindowProperty };
